import axios from "axios";
import { BASE_URL } from "./api.constant";
import {
  isUnauthorizedResponseBody,
  logoutDueToUnauthorized,
} from "./authSession";

const currentBaseUrl = BASE_URL;
let currentAccessToken: string | null = null;

export const httpClient = axios.create({
  baseURL: currentBaseUrl,
  headers: {
    Accept: "application/json",
    "Content": "application/json",
  },
});

httpClient.interceptors.response.use(
  (response) => {
    const payload = response?.data;
    if (isUnauthorizedResponseBody(payload)) {
      logoutDueToUnauthorized();
      return Promise.reject(payload);
    }
    return response;
  },
  (error) => {
    if (error?.response?.status === 401) {
      logoutDueToUnauthorized();
      return Promise.reject(error.response?.data ?? error);
    }
    if (error.response && isUnauthorizedResponseBody(error.response.data)) {
      logoutDueToUnauthorized();
      return Promise.reject(error.response.data);
    }
    if (error.response) {
      return Promise.reject(error.response.data);
    } else if (error.request) {
      return Promise.reject(new Error(error.request));
    } else {
      return Promise.reject(error);
    }
  }
);

/**
 * func update access token
 * @param token
 */
export function updateAccessToken(token: string | null) {
  if (token) {
    currentAccessToken = token;
    httpClient.defaults.headers.common.Authorization = `Bearer ${token}`;
  } else {
    currentAccessToken = null;
    // @ts-ignore
    httpClient.defaults.headers.common.Authorization = null;
  }
}

/**
 * func get current access token
 */
export function getCurrentAccessToken() {
  return currentAccessToken;
}
